import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick, toRaw } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { upsertCard } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import SelectEvse from '@/components/SelectEvse.vue'
import SelectUser from '@/components/SelectUser.vue'
import { IdType } from '@/types/types'
import FormRulesFactory from '@/common/formRules'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'CardUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  onlyLocalCard: {
    type: Boolean,
  },
  isEdit: {
    type: Boolean,
  },
  operatorID: {
    type: String,
    default: () => '0',
  },
  evseID: {
    type: String,
    default: () => '0',
  },
  cardInfo: {
    type: Object as PropType<Record<string, any>>,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const cardFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['card.operatorID', 'card.cardType'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(['card.cardNo'], 'inputEmpty', 'inputInvalid'),
})

const { cardTypes } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({ card: {} })

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const dialogTitle = computed(() => {
  if (props.isEdit) {
    return `${t('Base.edit')}`
  } else {
    return `${t('Base.add')}`
  }
})
const handleOpeenCardDialog = () => {
  nextTick(() => {
    // 清空校验
    formCom.value.clearValidate()
  })
}
watch(showDialog, async (val) => {
  if (props.isEdit) {
    formData.value.card = { ...props.cardInfo }
    console.log('🚀 ~ watch ~ props.cardInfo:', props.cardInfo)
    console.log('formData', formData.value)
  } else {
    // await nextTick()
    // formCom.value.clearValidate()
    formData.value.card = createRawFormData()

    if (props.operatorID != '0' && props.operatorID != '') {
      formData.value.card.operatorID = props.operatorID
    }
    if (props.evseID != '0' && props.evseID != '') {
      formData.value.card.evseID = props.evseID
      formData.value.card.cardType = IdType.IT_LOCAL_IDENTITY_CARD
    }
  }
})

const submit = async () => {
  try {
    await formCom.value.validate()
    if (formData.value.card.stationID == '') {
      formData.value.card.stationID = '0'
    }
    if (formData.value.card.evseID == '') {
      formData.value.card.evseID = '0'
    }
    if (formData.value.card.userID == '') {
      formData.value.card.userID = '0'
    }
    isSubmitting.value = true
    await upsertCard(formData.value)
    if (props.isEdit) {
      ElMessage.success(t(`Base.updateSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    title: _unref(dialogTitle),
    "z-index": 2000,
    onOpen: handleOpeenCardDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: cardFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.cardNo'),
                    prop: "card.cardNo",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.card.cardNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.card.cardNo) = $event)),
                        disabled: props.isEdit
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.cardType'),
                    prop: "card.cardType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.card.cardType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.card.cardType) = $event)),
                        disabled: props.isEdit || props.onlyLocalCard,
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cardTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value,
                              disabled: item.value == _unref(IdType).IT_LOCAL_WALLET_CARD
                            }, null, 8, ["label", "value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "card.operatorID",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: formData.value.card.operatorID,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.card.operatorID) = $event)),
                        disabled: props.isEdit || props.onlyLocalCard
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              (formData.value.card.cardType == _unref(IdType).IT_LOCAL_IDENTITY_CARD && formData.value.card.operatorID)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('Evses.equipment'),
                        prop: "card.evseID"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SelectEvse, {
                            modelValue: formData.value.card.evseID,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.card.evseID) = $event)),
                            operatorID: formData.value.card.operatorID,
                            disabled: props.isEdit || !formData.value.card.operatorID || props.onlyLocalCard
                          }, null, 8, ["modelValue", "operatorID", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
            formData.value.card.cardType == _unref(IdType).IT_ONLINE_IDENTITY_CARD && formData.value.card.operatorID
          )
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('Operation.user'),
                        prop: "card.userID"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SelectUser, {
                            modelValue: formData.value.card.userID,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.card.userID) = $event)),
                            operatorID: formData.value.card.operatorID,
                            name: formData.value.card.userName,
                            disabled: !props?.cardInfo?.userID || props?.cardInfo?.userID === '0',
                            isEdit: props.isEdit
                          }, null, 8, ["modelValue", "operatorID", "name", "disabled", "isEdit"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})